<template>
  <div class="basic-textarea-input-container">
    <label>{{ label }}</label>
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <textarea
        :ref="name"
        autocomplete="false"
        v-bind="field"
        :placeholder="placeholder"
        class="bordered"
        @input="onInput"
      />
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * placeholder: placeholder that'll be set inside the textarea (string)
 * value: text that'll be set inside the textarea, if null, then the placeholder we'll be displayed (string)
 * name: textarea's name (string)
 */
export default {
  name: 'BasicTextArea',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    defaultValue: [String, Array],
    name: String
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onInput({ target }) {
      this.mutatedValue = target.value.replaceAll(/[;:/\\[\]{}<>=%+]/g, '')
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .basic-textarea-input-container textarea {
    min-height: 15vh;
    width: 100%;
    resize: none;
    border-color: rgb(150 150 150);
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }
  }
</style>
